import { SECTIONS_WITH_SWIMLANE } from "../../constants/sections";

export const getSwimLaneList = (path) =>
    [].concat(SECTIONS_WITH_SWIMLANE[path] || []);
